"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Edit = void 0;

var _hook = _interopRequireDefault(require("./src/hook"));

var _vXETable = require("../v-x-e-table");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Edit = {
  install: function install() {
    _vXETable.VXETable.hooks.add('$tableEdit', _hook.default);
  }
};
exports.Edit = Edit;
var _default = Edit;
exports.default = _default;